export const positionSubscriptionStoreKey = 'positionSubscription';
